import { i18nTranslate } from 'src/utils'
import { isB2B2C } from 'src/utils'

const renderOptions = item => {
  const { name } = item
  const buyerNameMapping =
    name === 'ROLE_ACCOUNT_BUYER_ADMIN'
      ? 'Admin'
      : name === 'ROLE_ACCOUNT_BUYER'
      ? 'User'
      : name
  return {
    label: buyerNameMapping,
    value: buyerNameMapping,
  }
}

function getFormInput(props) {
  const {
    active = false,
    teams = [],
    roles = [],
    handleDropDownClick,
    handleRef,
  } = props
  const assignRole = {
    label: i18nTranslate('user.assignRole', 'Assign Role'),
    value: '',
  }
  const teamOptions = teams.map(renderOptions)
  const roleOptions = roles.map(renderOptions)
  roleOptions.unshift(assignRole)
  const formInput = [
    [
      {
        name: 'firstName',
        columnType: {
          lg: '6',
          md: '6',
          sm: '6',
          xs: '6',
        },
        // defaultValue: get(userResponse, 'firstName', ''),
        dataTestId: 'qa-first-name',
        ariaLabel: 'firstName',
        required: true,
      },
      {
        name: 'lastName',
        columnType: {
          lg: '6',
          md: '6',
          sm: '6',
          xs: '6',
        },
        // defaultValue: get(userResponse, 'lastName', ''),
        dataTestId: 'qa-last-name',
        ariaLabel: 'lastName',
        required: true,
      },
    ],
    // {
    //   name: 'userRole',
    //   type: 'select',
    //   columnType: {
    //     lg: 4,
    //     md: '6',
    //     sm: '6',
    //     xs: '6',
    //   },
    //   defaultValue: get(props, 'role', ''),
    //   options: roleOptions,
    //   disabled: !active,
    //   dataTestId: 'qa-assign-role-dropdown',
    //   customClassName: 'pt-2',
    // },
  ]

  if (!isB2B2C()) {
    formInput.push([
      {
        name: 'userEmailAddress',
        type: 'email',
        columnType: {
          lg: 6,
          md: '6',
          sm: '6',
          xs: '6',
        },
        defaultValue: props?.email || '',
        disabled: !active,
        maxLength: 254,
        dataTestId: 'qa-email-address',
        customClassName: 'pt-2',
        required: true,
      },
      {
        name: 'userTeam',
        type: 'selectWithCheckbox',
        initValue: { userTeam: [] },
        columnType: {
          lg: 6,
          md: '6',
          sm: '6',
          xs: '6',
        },
        defaultValue: props?.team || '',
        options: teamOptions,
        disabled: !active,
        customAttributes: {
          index: props.index,
        },
        handleRef: handleRef,
        handleDropDownClick: handleDropDownClick,
        dataTestId: 'qa-assign-team-dropdown',
        customClassName: 'pt-2',
      },
    ])
  } else {
    formInput.push([
      {
        name: 'userEmailAddress',
        type: 'email',
        columnType: {
          lg: 6,
          md: '6',
          sm: '6',
          xs: '6',
        },
        defaultValue: props?.email || '',
        disabled: !active,
        maxLength: 254,
        dataTestId: 'qa-email-address',
        customClassName: 'pt-2',
        required: true,
      },
    ])
  }
  /* @note As multiple team dropdown integrated
   * adding multiple form will reduce the performance
   * so, we are removing the add button
   */
  if (active) {
    // formInput.push({
    //   name: 'plusIconButton',
    //   type: 'inlineSubmitButton',
    //   customClassName: 'add-user position-absolute w-auto p-0',
    // })
    formInput.push({
      name: 'sendInviteButton',
      RenderProps: props.inviteButton,
    })
  }
  return formInput
}

export { getFormInput }
